import {
  docs_home,
  getting_started_apis,
  useful_terms,
  webhooks_guide,
  rate_limits,
  connect_sdk_start,
  connect_sdk_flow,
  connect_sdk_config,
  product_APIs,
  handling_errors,
  handling_webhooks,
  api_reference,
} from "./urls";

const helpGuides = [
  {
    heading: "",
    background_color: "#DEE8FC",
    items: [
      {
        title: "Discord Support",
        description:
          "Join Phyllo's vibrant community to get your queries answered by the team and collaborate with other developers building for the creator economy.",
        link: "https://discord.gg/FqPgyeWu37",
        event: "HELP_DISCORD_CLICK",
      },
      {
        title: "Documentation",
        description: "Look up the developer documentation on how to use Phyllo.",
        link: docs_home,
      },
      {
        title: "Contact sales",
        description: "Get in touch with our sales reps who can help you get access to production environment.",
        link: "https://www.getphyllo.com/talk-to-us-phyllo",
        event: "HELP_GO_LIVE_CLICK",
      },
    ],
  },
  {
    heading: "Guides",
    background_color: "#F5F5F7",
    items: [
      {
        title: "Getting started with Phyllo APIs",
        description: "If you are new to Phyllo, this is the place to get started.",
        link: getting_started_apis,
      },
      {
        title: "Important and useful terms",
        description: "What you should know when working with Phyllo.",
        link: useful_terms,
      },
      {
        title: "Webhooks guide",
        description: "Everything to know about Phyllo webhooks.",
        link: webhooks_guide,
      },
      {
        title: "Respecting rate limits",
        description: "A comprehensive guide on rate limits, and how to handle them the Phyllo way.",
        link: rate_limits,
      },
    ],
  },
  {
    heading: "Connect SDK",
    background_color: "#F5F5F7",
    items: [
      {
        title: "Getting started with Connect SDK",
        description: "Quick guide to work with the Phyllo Connect SDK.",
        link: connect_sdk_start,
      },
      {
        title: "Connect SDK flow",
        description: "Learn about choosing different onboarding flows for your users.",
        link: connect_sdk_flow,
      },
      {
        title: "Connect SDK configuration",
        description: "Customizing the Phyllo Connect SDK to suit your needs.",
        link: connect_sdk_config,
      },
    ],
  },
  {
    heading: "Phyllo APIs",
    background_color: "#F5F5F7",
    items: [
      {
        title: "Getting started with the APIs",
        description: "Quick guide to work with the Phyllo APIs.",
        link: product_APIs,
      },
      {
        title: "Handling errors",
        description: "Fantastic error codes and where to find them.",
        link: handling_errors,
      },
      {
        title: "Handling Phyllo webhooks",
        description: "You friendly neighbourhood guide for handling Phyllo webhooks.",
        link: handling_webhooks,
      },
      {
        title: "API references",
        description: "Complete API reference.",
        link: api_reference,
      },
    ],
  },
];

export default helpGuides;
